import { useContext, useState, useEffect, useMemo } from "react";
import NavbarV3 from "../../../components/NavbarV3/NavbarV3.tsx";
import "./OnTime.css";
import { useLocation } from "react-router-dom";
import ModalOnTime from "../../../components/ModalOnTime/ModalOnTime.tsx";
import ToastSucesso from "../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import ToastErro from "../../../components/Toast/ToastErro/ToastErro.tsx";
import ModalUsuario from "../../../components/ModalUsuario/ModalUsuario.tsx";
import TabelaRedux from "../../../contexts/Tabela";
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent.tsx";
import { motion } from "framer-motion";
import TabelaV2 from "../../../components/TabelaV2/TabelaV2";
import HeaderCadastro from "../../../components/HeaderCadastro/HeaderCadastro";
import CloseIcon from "../../../components/CloseIcon/CloseIcon";
import { getOnTimeSearch } from "../../../services/ModuloGerenciador/Search";
import FiltrosRedux from "../../../contexts/Filtros";
import FiltroV2 from "../../../components/FiltroV2/FiltroV2";
import { Card } from "primereact/card";
import ChartsHandler from "../../../components/Charts/ChartsHandler.tsx";
import ModalHistoricoEdicao from "../../../components/ModalHistoricoEdicao/ModalHistoricoEdicao.tsx";
import {
	getMotivoOnTime,
	vincularMotivoPorId,
} from "../../../services/ModuloGerenciador/MotivoOnTime";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import MultiplosFiltrosRedux from "../../../contexts/MultiplosFiltros.js";
import MotionSemAutorizacao from "../../../core/components/MotionSemAutorizacao.tsx";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import Separator from "../../../core/components/Separator.tsx";

const colunasEmbarque = [
	{
		nomeColuna: "Previsão",
		field: "dataHoraPrevisao",
	},
	{
		nomeColuna: "Chegada",
		field: "dataHoraChegada",
	},
	{
		nomeColuna: "Embarcado",
		field: "dataHoraAcontecido",
	},
	{
		nomeColuna: "Esperando",
		field: "tempoEsperando",
	},
	{
		nomeColuna: "Placa",
		field: "placaCaminhao",
	},
	{
		nomeColuna: "CTE",
		field: "cte",
	},
	{
		nomeColuna: "Cliente",
		field: "cliente",
	},
	{
		nomeColuna: "KM",
		field: "km",
	},
	{
		nomeColuna: "Motivo",
		field: "motivoOnTime",
	},
	{
		nomeColuna: "On Time",
		field: "onTime",
	},
	{
		nomeColuna: "Rota",
		field: "rota",
	},
];

const colunasEntrega = [
	{
		nomeColuna: "Previsão",
		field: "dataHoraPrevisao",
	},
	{
		nomeColuna: "Chegada",
		field: "dataHoraChegada",
	},
	{
		nomeColuna: "Entregue",
		field: "dataHoraAcontecido",
	},
	{
		nomeColuna: "Esperando",
		field: "tempoEsperando",
	},
	{
		nomeColuna: "Placa",
		field: "placaCaminhao",
	},
	{
		nomeColuna: "CTE",
		field: "cte",
	},
	{
		nomeColuna: "Cliente",
		field: "cliente",
	},
	{
		nomeColuna: "KM",
		field: "km",
	},
	{
		nomeColuna: "Motivo",
		field: "motivoOnTime",
	},
	{
		nomeColuna: "On Time",
		field: "onTime",
	},
	{
		nomeColuna: "Rota",
		field: "rota",
	},
];

const headersEmbarque = [
	{
		nomeColuna: "Percentual ON Time Embarque",
		field: "percentualOnTimeEmbarque",
		className: "card-ontime",
		unidade: "%",
	},
	{
		nomeColuna: "Percentual Ñ ON Time Embarque",
		field: "percentualNaoOnTimeEmbarque",
		className: "card-nao-ontime",
		unidade: "%",
	},
	{
		nomeColuna: "Tempo Esperando Embarque",
		field: "tempoEsperandoEmbarque",
		className: "card-ontime-azul",
		unidade: "h",
	},
	{
		nomeColuna: "Média Tempo Esperando Embarque",
		field: "tempoMedioEsperandoEmbarque",
		className: "card-ontime-azul",
		unidade: "h",
	},
];

const headersEntrega = [
	{
		nomeColuna: "Percentual ON Time Entrega",
		field: "percentualOnTimeEntrega",
		className: "card-ontime",
		unidade: "%",
	},
	{
		nomeColuna: "Percentual Ñ ON Time Entrega",
		field: "percentualNaoOnTimeEntrega",
		className: "card-nao-ontime",
		unidade: "%",
	},
	{
		nomeColuna: "Tempo Esperando Entrega",
		field: "tempoEsperandoEntrega",
		className: "card-ontime-azul",
		unidade: "h",
	},
	{
		nomeColuna: "Média Tempo Esperando entrega",
		field: "tempoMedioEsperandoEntrega",
		className: "card-ontime-azul",
		unidade: "h",
	},
];

const headersTotais = [
	{
		nomeColuna: "Percentual ON Time Total",
		field: "percentualOnTimeTotal",
		className: "card-ontime",
		unidade: "%",
	},
	{
		nomeColuna: "Percentual Ñ ON Time Total",
		field: "percentualNaoOnTimeTotal",
		className: "card-nao-ontime",
		unidade: "%",
	},
	{
		nomeColuna: "Tempo Esperando Total",
		field: "tempoEsperandoTotal",
		className: "card-ontime-azul",
		unidade: "h",
	},
	{
		nomeColuna: "Média Total Esperando",
		field: "tempoMedioEsperandoTotal",
		className: "card-ontime-azul",
		unidade: "h",
	},
];
const itensFiltro = [
	{
		nomeColuna: "Tipo Carroceria",
		field: "tipoCarroceria",
	},
	{
		nomeColuna: "Descrição",
		field: "descricao",
	},
	{
		nomeColuna: "Empresa",
		field: "empresa",
	},
	{
		nomeColuna: "Filial",
		field: "filial",
	},
	{
		nomeColuna: "Unidade de Embarque",
		field: "unidEmbarque",
	},
	{
		nomeColuna: "Cidade Origem",
		field: "cidadeOrigem",
	},
	{
		nomeColuna: "Estado Origem",
		field: "estadoOrigem",
	},
	{
		nomeColuna: "Cidade Destino",
		field: "cidadeDestino",
	},
	{
		nomeColuna: "Estado Destino",
		field: "estadoDestino",
	},
	{
		nomeColuna: "Pedido",
		field: "pedido",
	},
	{
		nomeColuna: "CTE",
		field: "cte",
	},
	{
		nomeColuna: "Previsão Viagem",
		field: "previsaoEmbarque",
	},
	{
		nomeColuna: "Data Viagem",
		field: "dataEmbarque",
	},
	{
		nomeColuna: "Previsão Entrega",
		field: "previsaoEntrega",
	},
	{
		nomeColuna: "Data Entrega",
		field: "dataEntrega",
	},
	{
		nomeColuna: "Data Hora Chegada Viagem",
		field: "dataHoraChegadaEmbarque",
	},
	{
		nomeColuna: "Data Hora Chegada Entrega",
		field: "dataHoraChegadaEntrega",
	},
	{
		nomeColuna: "Data Hora Entregue",
		field: "dataHoraEntregue",
	},
	{
		nomeColuna: "Data Hora Embarcado",
		field: "dataHoraEmbarcado",
	},
	{
		nomeColuna: "Aceite",
		field: "aceite",
	},
	{
		nomeColuna: "Status",
		field: "status",
	},
	{
		nomeColuna: "Placa Cavalo",
		field: "placaCavalo",
	},
	{
		nomeColuna: "Placa Carreta",
		field: "placaCarreta",
	},
	{
		nomeColuna: "Placa Segunda Carreta",
		field: "placaCarreta2",
	},
	{
		nomeColuna: "Proprietario",
		field: "proprietario",
	},
	{
		nomeColuna: "Motorista",
		field: "veiculoMotorista",
	},
	{
		nomeColuna: "ICMS",
		field: "icms",
	},
	{
		nomeColuna: "Frete Motorista",
		field: "freteMotorista",
		tipo: "number",
	},
	{
		nomeColuna: "Frete Fiscal",
		field: "freteFiscal",
		tipo: "number",
	},
	{
		nomeColuna: "Adicional Empresa",
		field: "adicionalEmpresa",
		tipo: "number",
	},
	{
		nomeColuna: "Adicional Motorista",
		field: "adicionalMotorista",
		tipo: "number",
	},
	{
		nomeColuna: "Pedagio",
		field: "pedagio",
		tipo: "number",
	},
	{
		nomeColuna: "Classificação",
		field: "classificacao",
		tipo: "number",
	},
	{
		nomeColuna: "Margem",
		field: "margem",
	},
	{
		nomeColuna: "Adiantamento",
		field: "adiantamento",
		tipo: "number",
	},
	{
		nomeColuna: "Saldo",
		field: "saldo",
		tipo: "number",
	},
	{
		nomeColuna: "Meio Pagamento",
		field: "meioPagamento",
	},
	{
		nomeColuna: "Meio Pagamento Dois",
		field: "meioPagamento2",
	},
	{
		nomeColuna: "Km",
		field: "km",
		tipo: "number",
	},
	{
		nomeColuna: "Cliente",
		field: "cliente",
	},
	{
		nomeColuna: "Embarcador",
		field: "embarcador",
	},
	{
		nomeColuna: "Destinatario",
		field: "destinatario",
	},
	{
		nomeColuna: "LOAD",
		field: "load",
	},
	{
		nomeColuna: "Mercadoria",
		field: "mercadoria",
	},
	{
		nomeColuna: "Peso",
		field: "peso",
		tipo: "number",
	},
	{
		nomeColuna: "Embalagem",
		field: "embalagem",
	},
	{
		nomeColuna: "Observação",
		field: "observacao",
	},
	{
		nomeColuna: "Frota",
		field: "frota",
	},
	{
		nomeColuna: "Cancelado",
		field: "cancelado",
	},
	{
		nomeColuna: "Motivo",
		field: "motivo",
	},
];

function OnTime(props) {
	const { profile, hasRegra, contextoEmbarque } = useProfile();

	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [numeroCargas, setNumeroCargas] = useState();

	const [listaMotivos, setListaMotivos] = useState([]);

	const [dadosTabelaEntrega, setDadosTabelaEntrega] = useState([]);

	const [dadosTabelaEmbarque, setDadosTabelaEmbarque] = useState([]);

	const [motivoId, setMotivoId] = useState();

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState([]);

	const [validator, setValidator] = useState([]);

	const [open, setOpen] = useState(false);

	const [textoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const [
		dadosClientesPioresIndicesEmbarque,
		setDadosClientesPioresIndicesEmbarque,
	] = useState([]);

	const [
		dadosClientesPioresIndicesEntrega,
		setDadosClientesPioresIndicesEntrega,
	] = useState([]);

	const [dadosFilial, setDadosFilial] = useState([]);

	const [dadosMotivosEmbarque, setDadosMotivosEmbarque] = useState([]);

	const [dadosMotivosEntrega, setDadosMotivosEntrega] = useState([]);

	const [dadosBoxplot, setBoxplot] = useState([]);

	const [dadosOnTime, setDadosOnTime] = useState([]);

	const [nomeMotivo, setNomeMotivo] = useState();

	const handleClose = () => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = () => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = () => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = () => {
		setOpenUsuario(false);
	};

	const [isEmbarque, setIsEmbarque] = useState(false);

	const [isEntrega, setIsEntrega] = useState(false);

	const vincularMotivoOnTime = async () => {
		let bool = false;
		if (isEmbarque === true) {
			bool = true;
		}
		if (isEntrega === true) {
			bool = false;
		}
		await vincularMotivoPorId(
			profile?.token,
			tabelaRedux.colunaSelecionada,
			motivoId,
			bool
		)
			.then((result) => {
				if (result.status === 200) {
					handleClose();
					buscarDadosDashboard4();
					buscarMotivo();
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const converterData = (data) => {
		const parts = data.split("-");
		return `${parts[2]}-${parts[1]}-${parts[0]}`;
	};

	const buscarDadosDashboard4 = async () => {
		if (!profile?.token) return;
		setLoading(true);
		var date = new Date();
		var primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1)
			.toLocaleDateString("pt-BR", {
				year: "numeric",
				month: "numeric",
				day: "numeric",
			})
			.replace(/\//g, "-");
		var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0)
			.toLocaleDateString("pt-BR", {
				year: "numeric",
				month: "numeric",
				day: "numeric",
			})
			.replace(/\//g, "-");
		const data1 = converterData(primeiroDia);
		const data2 = converterData(ultimoDia);
		const inicioFormatado = filtrosRedux.embarqueInicio
			? converterData(filtrosRedux.embarqueInicio)
			: undefined;
		const finalFormatado = filtrosRedux.embarqueFinal
			? converterData(filtrosRedux.embarqueFinal)
			: undefined;
		if (
			(Array.isArray(filtrosRedux) && filtrosRedux.length !== 0) ||
			(filtrosRedux &&
				Object.keys(filtrosRedux).length !== 0 &&
				filtrosRedux.constructor === Object)
		) {
			const pesquisaFormatada = `${filtrosRedux.item}=${filtrosRedux.pesquisa}`;
			await getOnTimeSearch(
				profile?.token,
				pesquisaFormatada,
				filtrosRedux.contexto ? filtrosRedux.contexto : "todos",
				filtrosRedux.embarqueInicio ? inicioFormatado : data1,
				filtrosRedux.embarqueFinal ? finalFormatado : data2
			)
				.then((result) => {
					setDadosClientesPioresIndicesEmbarque(
						result.data.clientesPioresIndicesEmbarque
					);
					setDadosClientesPioresIndicesEntrega(
						result.data.clientesPioresIndicesEntrega
					);
					setDadosTabelaEntrega(result.data.entrega);
					setDadosTabelaEmbarque(result.data.embarque);
					setDadosFilial(result.data.filial);
					setDadosMotivosEmbarque(result.data.motivosEmbarque);
					setDadosMotivosEntrega(result.data.motivosEntrega);
					setBoxplot(result.data.boxplot);
					setNumeroCargas(result.data.numeroDeCargasTotais);
					const arrayOnTime = [];
					arrayOnTime.push(result.data.percentualOnTimeEmbarque);
					arrayOnTime.push(result.data.percentualNaoOnTimeEmbarque);
					arrayOnTime.push(result.data.tempoEsperandoEmbarque);
					arrayOnTime.push(result.data.tempoMedioEsperandoEmbarque);
					arrayOnTime.push(result.data.percentualOnTimeEntrega);
					arrayOnTime.push(result.data.percentualNaoOnTimeEntrega);
					arrayOnTime.push(result.data.tempoEsperandoEntrega);
					arrayOnTime.push(result.data.tempoMedioEsperandoEntrega);
					arrayOnTime.push(result.data.percentualOnTimeTotal);
					arrayOnTime.push(result.data.percentualNaoOnTimeTotal);
					arrayOnTime.push(result.data.tempoEsperandoTotal);
					arrayOnTime.push(result.data.tempoMedioEsperandoTotal);
					setDadosOnTime(arrayOnTime);
					setLoading(false);
				})
				.catch((error) => {
					if (error.response?.status !== 200) {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					} else {
						setTextoErro(error.response.data);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		} else {
			await getOnTimeSearch(
				profile?.token,
				"undefined=undefined",
				"todos",
				data1,
				data2
			)
				.then((result) => {
					setDadosClientesPioresIndicesEmbarque(
						result.data.clientesPioresIndicesEmbarque
					);
					setDadosClientesPioresIndicesEntrega(
						result.data.clientesPioresIndicesEntrega
					);
					setDadosTabelaEntrega(result.data.entrega);
					setDadosTabelaEmbarque(result.data.embarque);
					setDadosFilial(result.data.filial);
					setDadosMotivosEmbarque(result.data.motivosEmbarque);
					setDadosMotivosEntrega(result.data.motivosEntrega);
					setBoxplot(result.data.boxplot);
					setNumeroCargas(result.data.numeroDeCargasTotais);
					const arrayOnTime = [];
					arrayOnTime.push(result.data.percentualOnTimeEmbarque);
					arrayOnTime.push(result.data.percentualNaoOnTimeEmbarque);
					arrayOnTime.push(result.data.tempoEsperandoEmbarque);
					arrayOnTime.push(result.data.tempoMedioEsperandoEmbarque);
					arrayOnTime.push(result.data.percentualOnTimeEntrega);
					arrayOnTime.push(result.data.percentualNaoOnTimeEntrega);
					arrayOnTime.push(result.data.tempoEsperandoEntrega);
					arrayOnTime.push(result.data.tempoMedioEsperandoEntrega);
					arrayOnTime.push(result.data.percentualOnTimeTotal);
					arrayOnTime.push(result.data.percentualNaoOnTimeTotal);
					arrayOnTime.push(result.data.tempoEsperandoTotal);
					arrayOnTime.push(result.data.tempoMedioEsperandoTotal);
					setDadosOnTime(arrayOnTime);
					setLoading(false);
				})
				.catch((error) => {
					if (typeof error?.response?.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		}
	};

	const buscarSearch = async () => {
		setLoading(true);
		let pesquisaFormatada = `${valuesPesquisa.item}=${valuesPesquisa.pesquisa}`;
		if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
			for (let filtro of multiplosFiltrosRedux) {
				pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
			}
		}
		await getOnTimeSearch(
			profile?.token,
			pesquisaFormatada,
			valuesPesquisa.contexto,
			valuesPesquisa.embarqueInicio,
			valuesPesquisa.embarqueFinal
		)
			.then((result) => {
				setDadosClientesPioresIndicesEmbarque(
					result.data.clientesPioresIndicesEmbarque
				);
				setDadosClientesPioresIndicesEntrega(
					result.data.clientesPioresIndicesEntrega
				);
				setDadosTabelaEntrega(result.data.entrega);
				setDadosTabelaEmbarque(result.data.embarque);
				setDadosFilial(result.data.filial);
				setDadosMotivosEmbarque(result.data.motivosEmbarque);
				setDadosMotivosEntrega(result.data.motivosEntrega);
				setBoxplot(result.data.boxplot);
				setNumeroCargas(result.data.numeroDeCargasTotais);
				const arrayOnTime = [];
				arrayOnTime.push(result.data.percentualOnTimeEmbarque);
				arrayOnTime.push(result.data.percentualNaoOnTimeEmbarque);
				arrayOnTime.push(result.data.tempoEsperandoEmbarque);
				arrayOnTime.push(result.data.tempoMedioEsperandoEmbarque);
				arrayOnTime.push(result.data.percentualOnTimeEntrega);
				arrayOnTime.push(result.data.percentualNaoOnTimeEntrega);
				arrayOnTime.push(result.data.tempoEsperandoEntrega);
				arrayOnTime.push(result.data.tempoMedioEsperandoEntrega);
				arrayOnTime.push(result.data.percentualOnTimeTotal);
				arrayOnTime.push(result.data.percentualNaoOnTimeTotal);
				arrayOnTime.push(result.data.tempoEsperandoTotal);
				arrayOnTime.push(result.data.tempoMedioEsperandoTotal);
				setDadosOnTime(arrayOnTime);
				setLoading(false);
			})
			.catch((error) => {
				if (error.response?.data?.length > 200) {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				} else {
					setTextoErro(error.response.data);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const buscarSearchReset = async () => {
		setLoading(true);
		const pesquisaFormatada = "undefined=undefined";
		await getOnTimeSearch(
			profile?.token,
			pesquisaFormatada,
			valuesPesquisa.contexto,
			valuesPesquisa.embarqueInicio,
			valuesPesquisa.embarqueFinal
		)
			.then((result) => {
				setDadosClientesPioresIndicesEmbarque(
					result.data.clientesPioresIndicesEmbarque
				);
				setDadosClientesPioresIndicesEntrega(
					result.data.clientesPioresIndicesEntrega
				);
				setDadosTabelaEntrega(result.data.entrega);
				setDadosTabelaEmbarque(result.data.embarque);
				setDadosFilial(result.data.filial);
				setDadosMotivosEmbarque(result.data.motivosEmbarque);
				setDadosMotivosEntrega(result.data.motivosEntrega);
				setBoxplot(result.data.boxplot);
				setNumeroCargas(result.data.numeroDeCargasTotais);
				const arrayOnTime = [];
				arrayOnTime.push(result.data.percentualOnTimeEmbarque);
				arrayOnTime.push(result.data.percentualNaoOnTimeEmbarque);
				arrayOnTime.push(result.data.tempoEsperandoEmbarque);
				arrayOnTime.push(result.data.tempoMedioEsperandoEmbarque);
				arrayOnTime.push(result.data.percentualOnTimeEntrega);
				arrayOnTime.push(result.data.percentualNaoOnTimeEntrega);
				arrayOnTime.push(result.data.tempoEsperandoEntrega);
				arrayOnTime.push(result.data.tempoMedioEsperandoEntrega);
				arrayOnTime.push(result.data.percentualOnTimeTotal);
				arrayOnTime.push(result.data.percentualNaoOnTimeTotal);
				arrayOnTime.push(result.data.tempoEsperandoTotal);
				arrayOnTime.push(result.data.tempoMedioEsperandoTotal);
				setDadosOnTime(arrayOnTime);
				setLoading(false);
			})
			.catch((error) => {
				if (error.response?.data?.length > 200) {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				} else {
					setTextoErro(error.response.data);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const buscarMotivo = async () => {
		if (!profile?.token) return;
		await getMotivoOnTime(profile?.token)
			.then((result) => {
				setListaMotivos(result.data);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const [valuesPesquisa, setValuesPesquisa] = useState([]);

	useEffect(() => {
			buscarDadosDashboard4();
			buscarMotivo();
		
	}, [contextoEmbarque]);

	const limpar = () => {
		setLoading(true);
		setValuesPesquisa([]);
		buscarSearchReset();
	};

	const [showTables, setShowTables] = useState(true);

	const handleClickShowTables = () => {
		setShowTables(!showTables);
	};

	useEffect(() => {
		setValues((current) => ({
			...current,
			usuario: profile?.usuario.usuario,
		}));
		setValidator((current) => ({ ...current, nome: "false" }));
	}, [loading]);

	useEffect(() => {
		if (!!props.telaCadastro) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("On Time"));
			buscarDadosDashboard4();
			buscarMotivo();
		}
	}, [profile?.token, hasRegra]);

	const [openHistoricoEdicao, setOpenHistoricoEdicao] = useState(false);

	const handleCloseHistoricoEdicao = () => {
		setOpenHistoricoEdicao(false);
	};

	const location = useLocation();

	const { filtrosRedux, setFiltrosRedux } = useContext(FiltrosRedux);

	useEffect(() => {
		setValuesPesquisa((current) => ({
			...current,
			item: undefined,
			pesquisa: undefined,
		}));
		setFiltrosRedux((current) => ({
			...current,
			item: undefined,
			pesquisa: undefined,
		}));
	}, [location.pathname]);

	const isLoading = useMemo(() => {
		return loading || !profile?.token;
	}, [loading, profile?.token]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<NavbarV3 title="On Time" selecionado="Todos" />
			{!isLoading ? (
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
				>
					{!telaCadastro ? (
						<div className="embarques">
							<div className="filtro-cliente-v2">
								<FiltroV2
									classe="div-filtrar-embarque-v2"
									classOption="select-options-cliente"
									itensFiltro={itensFiltro}
									valuesPesquisa={valuesPesquisa}
									setValuesPesquisa={setValuesPesquisa}
									buscarSearch={buscarSearch}
									limpar={limpar}
								/>
								<div className="pointer" onClick={handleClickShowTables}>
									{showTables ? <Visibility /> : <VisibilityOff />}
								</div>
							</div>
							<Separator size="xl" />
							<div className="numero-embarques">
								<h3 style={{ textAlign: "center" }}>
									Número de cargas: {numeroCargas}
								</h3>
							</div>
							<div className="container-faturamento-ontime">
								<div className="div-card-ontime">
									{headersEmbarque.map((header, i) => (
										<div className={header.className} key={header.field}>
											<div className="card-header-ontime">
												{header.nomeColuna}
											</div>
											<div className="card-body">
												{dadosOnTime[i]} {header.unidade}
											</div>
										</div>
									))}
								</div>
								<div className="div-card-ontime">
									{headersEntrega.map((header, i) => (
										<div className={header.className} key={header.field}>
											<div className="card-header-ontime">
												{header.nomeColuna}
											</div>
											<div className="card-body">
												{dadosOnTime[i + 4]} {header.unidade}
											</div>
										</div>
									))}
								</div>
								<div className="div-card-ontime">
									{headersTotais.map((header, i) => (
										<div className={header.className} key={header.field}>
											<div className="card-header-ontime">
												{header.nomeColuna}
											</div>
											<div className="card-body">
												{dadosOnTime[i + 8]} {header.unidade}
											</div>
										</div>
									))}
								</div>
							</div>
							{showTables && (
								<div className="principal-ontime">
									<div className="container-ontime">
										<h2 className="text-ontime">Viagens</h2>
										<TabelaV2
											setOpenHistoricoEdicao={setOpenHistoricoEdicao}
											setOpen={setOpen}
											isEmbarque={true}
											setIsEmbarque={setIsEmbarque}
											setIsEntrega={setIsEntrega}
											classeSelecionado="embarqueId"
											nomeClasse1="outer-wrapper-rota"
											nomeClasse2="table-wrapper-v2-sem-scroll"
											colunas={colunasEmbarque}
											dados={dadosTabelaEmbarque}
										/>
									</div>
									<div className="container-ontime">
										<h2 className="text-ontime">Entregas</h2>
										<TabelaV2
											setOpenHistoricoEdicao={setOpenHistoricoEdicao}
											setOpen={setOpen}
											isEmbarque={false}
											setIsEntrega={setIsEntrega}
											setIsEmbarque={setIsEmbarque}
											classeSelecionado="embarqueId"
											nomeClasse1="outer-wrapper-rota"
											nomeClasse2="table-wrapper-v2-sem-scroll"
											colunas={colunasEntrega}
											dados={dadosTabelaEntrega}
										/>
									</div>
								</div>
							)}
							<div className="charts">
								{!isLoading ? (
									<div>
										<div className="graficosCima">
											<div className="item">
												<Card>
													<ChartsHandler
														data={dadosClientesPioresIndicesEmbarque ?? []}
														type={"pie-negative"}
														height={300}
														width={570}
														title={"Clientes Piortes Indices Embarque"}
													/>
												</Card>
											</div>
											<div className="item">
												<Card>
													<ChartsHandler
														data={dadosClientesPioresIndicesEntrega ?? []}
														type={"pie-negative"}
														height={300}
														width={570}
														title={"Clientes Piortes Indices Entrega"}
													/>
												</Card>
											</div>
											<div className="item">
												<Card>
													<ChartsHandler
														data={dadosFilial ?? []}
														type={"pie"}
														height={300}
														width={570}
														title={"Filial"}
													/>
												</Card>
											</div>
											<div className="item">
												<Card>
													<ChartsHandler
														data={dadosMotivosEmbarque ?? []}
														type={"pie"}
														height={300}
														width={570}
														title={"Motivos"}
													/>
												</Card>
											</div>
											<div className="item">
												<Card>
													<ChartsHandler
														data={dadosMotivosEntrega ?? []}
														type={"pie"}
														height={300}
														width={570}
														title={"Motivos"}
													/>
												</Card>
											</div>
										</div>
										<div className="item-box-plot">
											<Card>
												<ChartsHandler
													data={dadosBoxplot}
													type={"boxplot"}
													height={700}
													width={570}
													title={"BoxPlot"}
												/>
											</Card>
										</div>
										<br />
										<br />
									</div>
								) : (
									<LoadingComponent />
								)}
							</div>
						</div>
					) : (
						<div>
							{!props.desabilitar && (
								<div className="indicadores">
									<p className="indicador-emb">{"Dados de OnTime / "}</p>
									<p className="indicador-emb">{"Cadastro de OnTime"}</p>
								</div>
							)}
							<div className="flex">
								{!props.botaoVoltar && (
									<div className="flex-emb">
										<HeaderCadastro texto="Cadastro de OnTime" />
										<CloseIcon
											onClick={() => {
												setValues({});
												setTelaCadastro(false);
												setEditando(false);
												setTabelaRedux({});
											}}
										/>
									</div>
								)}
							</div>
							<div className="flex-column">
								<div className="container-select-emb">
									<div className="rota-div-2">
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Nome OnTime:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{ width: "270px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															nome: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															nome: "true",
														}));
													}}
													placeholder="Ex: Pallet"
													value={values.nome}
													disabled={props.desabilitar}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					)}
					<div>
						<ModalOnTime
							titulo="Vincular Motivo"
							tituloConfirmar="Confirmar"
							tituloCancelar="Cancelar"
							open={open}
							onClose={handleClose}
							onClick={vincularMotivoOnTime}
							listaMotivos={listaMotivos}
							setMotivoId={setMotivoId}
							setNomeMotivo={setNomeMotivo}
						/>
						<ModalHistoricoEdicao
							valueTabela={tabelaRedux}
							valueDados={tabelaRedux.row}
							valueUnico={values}
							open={openHistoricoEdicao}
							onClose={handleCloseHistoricoEdicao}
							titulo="Viagem"
							classeSelecionado="idEmbarque"
							colunas="Embarque"
							nome="embarque"
							nomeTable="Embarque"
						/>
						<ModalUsuario
							titulo="Usuário"
							tituloConfirmar="OK"
							open={openUsuario}
							onClose={handleCloseUsuario}
						/>
					</div>
					<div>
						<ToastSucesso
							texto={textoSucesso}
							open={openToastSucesso}
							onClose={handleCloseToastSucesso}
						/>
						<ToastErro
							texto={textoErro}
							open={openToastErro}
							onClose={handleCloseToastErro}
						/>
					</div>
				</motion.div>
			) : (
				<LoadingComponent />
			)}
		</motion.div>
	);
}

export default OnTime;
